import classNames from "classnames";
import * as React from "react";

import { Search } from "@/shared/foundation/icons";

import { TextInput, type TextInputProps } from "../TextInput";

import styles from "./SearchInput.module.css";

/**
 * A native input's props, less `type` and `size`: the input is always a
 * search box, as tall as the toolbar buttons beside it.
 */
export interface SearchInputProps extends Omit<
  TextInputProps,
  "type" | "size"
> {
  /** Applied to the wrapper, so it sets the box's width (240px by default). */
  className?: string;
}

/**
 * A search box with a magnifier icon, as tall as a toolbar's Filter and
 * Columns buttons. Pass `aria-label`, since a toolbar has no visible label.
 */
export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  function SearchInput({ className, ...props }, ref) {
    return (
      <label className={classNames(styles.search, className)}>
        <Search size={16} aria-hidden className={styles.searchIcon} />
        <TextInput
          ref={ref}
          size="sm"
          type="search"
          className={styles.searchInput}
          {...props}
        />
      </label>
    );
  },
);
